import React from "react";
import { ProductSpecification } from "../../services/productService";

interface ProductSpecificationsProps {
  specifications: ProductSpecification[];
}

const ProductSpecifications: React.FC<ProductSpecificationsProps> = ({
  specifications,
}) => {
  if (!specifications || specifications.length === 0) {
    return null;
  }

  const sortedSpecs = [...specifications].sort(
    (a, b) => a.displayOrder - b.displayOrder
  );

  return (
    <div className="product-specifications">
      <h3 className="text-[#0d171b] dark:text-white text-lg font-bold leading-tight mb-4">
        المواصفات
      </h3>
      <div className="space-y-3">
        {sortedSpecs.map((spec) => (
          <div
            key={spec.id}
            className="flex justify-between items-start border-b border-slate-200 dark:border-slate-700 pb-2"
          >
            <dt className="font-medium text-slate-700 dark:text-slate-300 text-base">
              {spec.specKey}
            </dt>
            <dd className="text-[#0d171b] dark:text-white text-base text-right flex-1 mr-4">
              {spec.specValue}
            </dd>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductSpecifications;
